import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { inkLight } from '../../styles/design-tokens';
import { Button } from '../../ui-library/button/button';
import { Icon } from '../../ui-library/icon/icon';
import { Text } from '../../ui-library/typography/typography';
import { SmallSquareButton } from '../small-square-button/small-square-button';

type Props = {
  onResetFilters: () => void;
  onClose?: () => void;
};

export const FilterPanelHeader = ({ onResetFilters, onClose }: Props) => {
  const i18n = useTranslation();
  return (
    <Group justify="space-between">
      <Text weight="medium" textKey="common.filters">
        {i18n.t('common.filters')}
      </Text>
      <Group gap="xs">
        <Button
          variant="outline"
          size="xs"
          radius="xl"
          leftSection={<Icon name="restart_alt" size={16} color={inkLight} style={{ cursor: 'pointer' }} />}
          onClick={onResetFilters}
          style={{ padding: '8px 16px' }}
        >
          <Text size="small" lineHeight="none" color={inkLight}>
            {i18n.t('common.actions.reset')}
          </Text>
        </Button>
        {onClose && (
          <SmallSquareButton onClick={onClose} iconName="arrow_back_ios" aria-label={i18n.t('common.close_filters')} />
        )}
      </Group>
    </Group>
  );
};
